import { useMemo } from "react";
import { format, addDays } from "date-fns";
import { CourtGridData, CourtGridTimeSlot } from "../../../models/CourtGridData";

interface UseWeeklyFilteringProps {
  weeklyGridData: CourtGridData[];
  startDate: Date;
  isMobile: boolean;
}

export default function useWeeklyFiltering({ weeklyGridData, startDate, isMobile }: UseWeeklyFilteringProps) {
  // Uzupełnienie brakujących dni - zawsze mamy pełny zakres
  const completeWeeklyGridData = useMemo(() => {
    const daysCount = isMobile ? 1 : 7;
    const completeDays: CourtGridData[] = [];

    for (let i = 0; i < daysCount; i++) {
      const currentDate = addDays(startDate, i);
      const formattedDate = format(currentDate, "yyyy-MM-dd");

      // Sprawdź czy mamy dane dla tego dnia
      const existingData = weeklyGridData.find((d) => d.date === formattedDate);

      if (existingData) {
        completeDays.push(existingData);
      } else {
        // Dodaj pusty dzień jeśli nie ma danych z API
        completeDays.push({
          date: formattedDate,
          courts: [
            {
              courtName: "",
              imageUrl: "",
              description: "",
              timeSlots: [],
            },
          ],
        });
      }
    }

    return completeDays;
  }, [weeklyGridData, startDate, isMobile]);

  // Wyodrębnienie wszystkich unikalnych godzin ze wszystkich dni
  const uniqueHours = useMemo(() => {
    const hours = new Set<string>();
    completeWeeklyGridData.forEach((dayData) => {
      if (dayData.courts && dayData.courts.length > 0) {
        dayData.courts[0].timeSlots.forEach((slot) => {
          hours.add(slot.startTime);
        });
      }
    });
    return Array.from(hours).sort();
  }, [completeWeeklyGridData]);

  // Funkcja do znalezienia slotu dla danej daty i godziny
  const findSlot = (date: string, startTime: string): CourtGridTimeSlot | undefined => {
    const dayData = completeWeeklyGridData.find((d) => d.date === date);
    if (!dayData || !dayData.courts || dayData.courts.length === 0) return undefined;
    return dayData.courts[0].timeSlots.find((slot) => slot.startTime === startTime);
  };

  return {
    uniqueHours,
    findSlot,
    weeklyGridData: completeWeeklyGridData,
  };
}

